import DefaultLandingNavbar from 'components/navbars/default-landing-navbar/DefaultLandingNavbar';
import HeroHeader from 'components/modules/landing/default/HeroHeader';
import FeaturesLaboral from 'components/modules/landing/default/features/FeaturesLaboral';
import TerminosDeServicio from 'components/modules/landing/default/blog/BlogTerminosDeServicio'; // Usamos el componente Blog adaptado
import Testimonial from 'components/modules/landing/default/testimonial/Testimonial';
import PorQueNosotros from 'components/modules/landing/default/fun-facts/FunFacts'; // Usamos FunFacts adaptado
import AddressSection from 'components/modules/landing/default/address/AddressSection'; // Contiene Ubicación, FAQ y Contacto
import Cta from 'components/modules/landing/default/Cta'; // Dejanos tu opinión
import Footer from 'components/modules/landing/default/Footer';
import useSettingsMountEffect from 'hooks/useSettingsMountEffect';

const DefaultTerminosDeServicio = () => {
  useSettingsMountEffect({
    disableNavigationType: true,
    disableHorizontalNavbarAppearance: true,
    disableVerticalNavbarAppearance: true,
    disableHorizontalNavbarShape: true
  });

  return (
    <div className="bg-body-emphasis">
      <DefaultLandingNavbar />
      <TerminosDeServicio />
      <Footer />
    </div>
  );
};

export default DefaultTerminosDeServicio;